import {
  ICategory,
  IProduct,
} from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

export const getCategoriesFiltered = (
  categories: ICategory[],
  soldOutIds: number[]
): ICategory[] => {
  if (!Array.isArray(categories)) return []
  const soldOutSet = new Set(soldOutIds)
  const mark = (product: IProduct): IProduct => ({
    ...product,
    soldOut: soldOutSet.has(product.id),
    ...(product.innerCategoryItems?.length
      ? { innerCategoryItems: product.innerCategoryItems.map(mark) }
      : {}),
  })
  return categories.map((category) => ({
    ...category,
    products: category.products.map(mark),
  }))
}
